/**
 * Rôles applicatifs — libellés FR et helpers de comparaison.
 *
 * Le rôle courant ne vient JAMAIS d'ici ni d'un décodage de JWT : il est servi
 * par `GET /api/me` et exposé par `useAuthStore().role` (spec §5.2).
 */
import { AppRole, ROLE_PRIORITY } from '@/shared/enums';

export const ROLE_LABELS_FR: Record<AppRole, string> = {
  [AppRole.ADMIN]: 'Administrateur',
  [AppRole.AMESURA]: 'Équipe Amesura',
  [AppRole.CLIENT]: 'Client',
};

export function roleLabel(role: AppRole | null): string {
  if (role === null) return 'Aucun rôle';
  return ROLE_LABELS_FR[role];
}

export function hasRole(role: AppRole | null, allowed: readonly AppRole[]): boolean {
  if (role === null) return false;
  return allowed.includes(role);
}

/** Rôles internes (non client). */
export const INTERNAL_ROLES: readonly AppRole[] = [AppRole.ADMIN, AppRole.AMESURA];

/**
 * Résout la valeur brute renvoyée par `GET /api/me` (littéral Keycloak) en membre
 * d'enum `AppRole`. La recherche suit `ROLE_PRIORITY` : le rôle le plus privilégié
 * gagne si la valeur venait un jour d'une liste. Valeur inconnue ⇒ `null`.
 */
export function appRoleFromValue(value: string | null | undefined): AppRole | null {
  if (!value) return null;
  return ROLE_PRIORITY.find((role) => role === value) ?? null;
}
